import gql from "graphql-tag";

export const FORGOT_PASSWORD = gql`
  query sendResetPasswordLink($email: String!) {
    sendResetPasswordLink(email: $email)
  }
`;